import rest from '../../rest/config'

const state = {
  status: 1,
  detailInfo: {
  }
}

const actions = {
  fetchConditionReport({ commit }, {
    auctionId,
    ticketCarId
  }) {
    return rest.usedCar.getConditionReport('', {
      auction_car_info_id: auctionId,
      ticket_car_id: ticketCarId
    }).then((res) => {
      if (res.code !== 0) {
        return
      }

      commit('UPDATE_CAR_CONDITION_INFO', res.data)
      return res.data
    })
  }
}

const mutations = {
  'UPDATE_CAR_CONDITION_INFO': function(state, conditionInfo) {
    const {
      status,
      detail_info: detailInfo
    } = conditionInfo

    state.status = status
    state.detailInfo = detailInfo
  }
}

export default {
  state,
  actions,
  mutations,
  namespaced: true
}
